import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Client-side gate for /admin/*.
 *
 * Defence in depth only — the server re-verifies the token on every request, so this
 * exists to avoid rendering an admin shell that is guaranteed to 401. Whenever it
 * denies access it also clears the cached session, so a rejected token can never
 * leave a stale `adminUser` behind for the UI to read.
 */
const clearSession = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
};

const hasValidSession = () => {
  const token = localStorage.getItem('adminToken');

  // Covers both "never logged in" and the empty-string case a partial write can leave.
  if (!token) {
    clearSession();
    return false;
  }

  try {
    const { exp } = JSON.parse(atob(token.split('.')[1]));
    if (exp && exp < Date.now() / 1000) {
      clearSession();
      return false;
    }
  } catch (error) {
    // Malformed or non-JWT token — treat exactly like an expired one.
    clearSession();
    return false;
  }

  return true;
};

export const ProtectedRoute = ({ children }) => {
  if (!hasValidSession()) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};
